import { render, staticRenderFns } from "./ExibirFormulario.vue?vue&type=template&id=5a978c64&scoped=true&"
import script from "./ExibirFormulario.vue?vue&type=script&lang=js&"
export * from "./ExibirFormulario.vue?vue&type=script&lang=js&"
import style0 from "./ExibirFormulario.vue?vue&type=style&index=0&id=5a978c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a978c64",
  null
  
)

export default component.exports